import React from "react";
import { connect } from "react-redux";
import KIT from "../../Descargable/Kit de Apoyo E1.zip";
import { dataLayerTag } from "../functions";

class KitSensibilizacionPlanMovilidad extends React.PureComponent {
  render() {
    return (
      <div className="row">
        <div className="col-sm-9 text-left">
          <div className="PM-cuadro-3">
            <h5><strong>Descargar el kit de difusión que contiene el siguiente material de apoyo:</strong></h5>
            <ul>
              <li>Una plantilla de mailing personalizable con el logo de tu empresa</li>
              <li>Un video para que lo trabajadores entiendan la importancia del problema que estamos abordando</li>
              <li>Afiche para pegar en los murales de tu empresa</li>
              <li>Gif para compartir por WhatsApp</li>
              <li>Pie de firma para tu correo</li>
            </ul>
          </div>
        </div>
        <div className="col-sm-3 btn-material">
          <button
            className="btn PM-dx-button-plan PM-dx-button-plan-100 PM-button-light"
            onClick={() => {
              window.open(KIT,'_blank');
              dataLayerTag({
                'event': 'etapa_1_descarga_kit',
                'etapa': '1'
              });
            }}
          >Descargar kit</button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = () => ({
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(KitSensibilizacionPlanMovilidad);
